import { sendSoundMessage } from '_api/voice';
import { mapGetters } from 'vuex/dist/vuex.common.js';
import EventBus from '_lib/EventBus';

export default {
  data() {
    return {
      pauseTimer: null
    }
  },
  computed: {
    ...mapGetters(['laughter_flatten_list', 'cur_channel_data'])
  },
  created() {
    // 初始化
    this.clientInitRoulette()
  },
  beforeDestroy() {
    clearTimeout(this.pauseTimer)
  },
  methods: {
    clientInitRoulette() {
      if (!process.env.IS_CLIENT) {
        return
      }
      this.getRequestFromRoulette()
    },
    getRequestFromRoulette() {
      const fn = (item) => {
        if (this.isMicMute) {
          EventBus.$emit('set_dialog_visible:mutedByAdmin', '播放语音包')
          return
        }
        EventBus.$emit('Laughter_Play_State_Change', item.path)
        sendSoundMessage({}, {
          room_id: this.cur_channel_data.room_id,
          channel_id: this.cur_channel_data.channel_id,
          path: item.path,
          name: item.name,
          ext: item.ext,
          volume: item.volume
        })
        clearTimeout(this.pauseTimer)
        this.pauseTimer = setTimeout(() => {
          EventBus.$emit('Laughter_Play_State_Change', '')
        }, item.duration * 1000)
      }
      window.laughterAPI.getRequestFromSub(fn)
    }
  }
}
